import { ISiteDetailMetadata } from '../../settings.types';
import SiteSearchPreviewCard from './site-search-preview-card';

const SiteSearchCardList = ({ metadata }: { metadata?: ISiteDetailMetadata }) => {
  const cards = Array.from({ length: 5 }, (_, index) => (
    <SiteSearchPreviewCard
      key={index}
      name={metadata?.name || ''}
      description={metadata?.description || ''}
      blank={index > 0}
    />
  ));
  return <>{cards}</>;
};

export default SiteSearchCardList;
